import config from '../config'
import carbuyservice from '../api/clients/carBuyService'

export default {
  getActiveDispositions: async function () {
    return await carbuyservice.get(`/QuoteStatusType`);
  },
  getAllDispositions: async function () {
    return await carbuyservice.get(`/QuoteStatusType/all`);
  },
  getAllDispositionTypes: async function () {
    return await carbuyservice.get('/QuoteStatusCategoryType/Active');
  },
  create: async function (data) {
    return await carbuyservice.post(`/QuoteStatusType`, data, true);
  },
  update: async function (data) {
    return await carbuyservice.put(`/QuoteStatusType`, data, true);
  },
  getActiveFollowupResultTypes: async function () {
    return await carbuyservice.get('/FollowupResultType/Active');
  }
}



// WEBPACK FOOTER //
// ./src/api/dispositions.js